/**
 * Destinations a home tile may point at (HOME-04/05). Organizers choose which tiles appear,
 * their order and their labels; the attendee app maps these keys to routes.
 */
export const HOME_TILE_INTERNAL_KEYS = [
  'agenda',
  'speakers',
  'directory',
  'matches',
  'schedule',
  'announcements',
  'venue',
  'profile',
  'info',
] as const;

export type HomeTileInternalKey = (typeof HOME_TILE_INTERNAL_KEYS)[number];

export function isHomeTileInternalKey(value: string): value is HomeTileInternalKey {
  return (HOME_TILE_INTERNAL_KEYS as readonly string[]).includes(value);
}

/**
 * The client's own destinations, kept in `events.links` (HOME-05, footer). They are one JSONB
 * column rather than columns or tile rows because the footer needs them addressable by name,
 * while a tile is a positioned, renamable entry the organizer curates.
 */
export const EVENT_LINK_KEYS = [
  'website',
  'privacy',
  'donate',
  'mentorshipDonation',
  'golf',
  'silentAuction',
  'store',
  'mediaKit',
] as const;

export type EventLinkKey = (typeof EVENT_LINK_KEYS)[number];
export type EventLinks = Partial<Record<EventLinkKey, string>>;
